window.RecuperaSenhaPage={
    data: {
        email: "",
        formHandler: null
    },
    get: function (ev) {
        return eval("RecuperaSenhaPage.data."+ev);
    },
    watch: {
        email(){
            return new Promise((resolve,reject) => {
                if(FormGenericValidator.required($('#email').val())){
                    if(FormGenericValidator.email($('#email').val())){
                        $('#emailSpinner').css({display: "inline-block"});
                        FormGenericValidator
                            .emailExists(
                                $('#email').val(),
                                urls.validate_email,
                                'recover'
                            )
                            .then((notExists) => {
                                console.log(notExists);
                                $('#emailSpinner').hide();
                                if(!notExists){
                                    BSForm.success($('#email'),$('#spanEmailErro'));
                                    resolve(true);
                                }else {
                                    BSForm.error($('#email'),$('#spanEmailErro'),"Nenhum e-mail correspondente foi encontrado");
                                    resolve(false);
                                }
                            });
                    }else{
                        BSForm.error($('#email'),$('#spanEmailErro'),"Favor informar um e-mail válido");
                        resolve(false);
                    }
                }else {
                    BSForm.error($('#email'),$('#spanEmailErro'),"Este campo deve ser preenchido");
                    resolve(false);
                }
            });
        },
        form_send(){
            RecuperaSenhaPage
                .watch
                .email()
                .then((go) => {
                    if(go) {
                        $('#formRecuperarSenha').unbind('submit', RecuperaSenhaPage.data.formHandler);
                        $('#formRecuperarSenha').unbind('submit', RecuperaSenhaPage.watch.form_send);
                        $('#formRecuperarSenha').submit();
                    }
                })
        }
    },
    load(){
        let self=RecuperaSenhaPage;
        self.data.formHandler=function (e) {
            e.preventDefault();
            return false;
        };
        $('#formRecuperarSenha').on('submit',self.data.formHandler);
        $('#formRecuperarSenha').on('submit',self.watch.form_send);
        $('#formRecuperarSenha #email').on('change',self.watch.email);
    }
};
RecuperaSenhaPage.load();